import { render, staticRenderFns } from "./CostsSummaryTable.vue?vue&type=template&id=961670fa&scoped=true&"
import script from "./CostsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./CostsSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961670fa",
  null
  
)

export default component.exports